import * as React from "react"

import Link from "../Link"

interface Props {
    attributes: Record<string, string>
    label: string
}

// OPENS THE SITE INFORMATION DETAIL PAGE (TES)
export const SiteInternalLink = ({ attributes, label }: Props): JSX.Element => {
    const href = "config/siteinformation"

    return <Link attributes={attributes} label={label} href={href} />
}

export default SiteInternalLink
